const dayMs = 24 * 60 * 60 * 1000;

export const jakartaDate = (now = new Date()) => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Jakarta', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(now);

export const simDueState = (paidUntil, today = jakartaDate()) => {
  if (!paidUntil) return 'unknown';
  const due = Date.parse(`${paidUntil}T00:00:00Z`);
  const base = Date.parse(`${today}T00:00:00Z`);
  if (Number.isNaN(due) || Number.isNaN(base)) return 'unknown';
  const days = Math.round((due - base) / dayMs);
  if (days < 0) return 'expired';
  if (days <= 7) return 'urgent';
  if (days <= 30) return 'soon';
  return 'ok';
};

export const formatJakartaDate = (value, language = 'id') => {
  if (!value) return '-';
  const date = new Date(`${value}T00:00:00+07:00`);
  if (Number.isNaN(date.getTime())) return '-';
  const locale = language.startsWith('zh') ? 'zh-CN' : language.startsWith('id') ? 'id-ID' : 'en-US';
  return new Intl.DateTimeFormat(locale, { timeZone: 'Asia/Jakarta', year: 'numeric', month: 'short', day: '2-digit' }).format(date);
};
